import { render, staticRenderFns } from "./ChallengeDetails.vue?vue&type=template&id=5815e749"
import script from "./ChallengeDetails.vue?vue&type=script&lang=js"
export * from "./ChallengeDetails.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports